import { QueryClient } from "@tanstack/react-query"

const FIVE_MINUTES = 5 * 60 * 1000
const ONE_HOUR = 60 * 60 * 1000

/**
 * A 401 clears the token and is retried once so a silent renew can land. Other
 * 4xx responses are not worth retrying.
 */
const isRetriable = (failureCount: number, error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response?.status

  if (status !== undefined && status >= 400 && status < 500) {
    return status === 401 && failureCount < 1
  }

  return failureCount < 2
}

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: FIVE_MINUTES,
        gcTime: ONE_HOUR,
        retry: isRetriable,
        refetchOnWindowFocus: false,
      },
    },
  })
